import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { object } from 'yup';

import { create, readPin, reset } from 'next/entities/pins';
import { Shape as PinShape } from 'next/entities/experiences';
import { asRequest, NEW_ITEM_ID } from 'next/entities/requests';
import {
  selectDefaultThemeOption,
  selectTagsOptions,
  selectThemesOptions,
} from 'next/lib/selectors-options';
import { OptionShape, SelectOptionsShape } from 'next/lib/shapes';

import {
  PIN_TYPE,
  CreateExperienceModalManager,
} from 'next/components/CreateExperience';

import ThemesField from './ThemesField';

const validationSchema = { theme: object().required('Theme is required') };

export const NewPinManager = ({
  defaultThemeOption,
  onOpen,
  onSubmit,
  pinStatus = {},
  tagOptions,
  themeOptions,
}) => {
  const handleSubmit = values =>
    onSubmit({
      name: values.name,
      preview_url: values.previewUrl,
      theme: values.theme.value,
      tagIds: values.tagIds,
      type: 'persistent',
    });

  const initialValues = { theme: defaultThemeOption };

  return (
    <CreateExperienceModalManager
      initialValues={initialValues}
      onOpen={onOpen}
      onSubmit={handleSubmit}
      type={PIN_TYPE}
      renderAdditionalFields={({ onChange }) => (
        <ThemesField
          defaultThemeOption={defaultThemeOption}
          onChange={theme => onChange({ theme })}
          themeOptions={themeOptions}
        />
      )}
      status={pinStatus}
      tags={tagOptions}
      validationSchema={validationSchema}
    />
  );
};

NewPinManager.propTypes = {
  defaultThemeOption: OptionShape,
  onOpen: PropTypes.func,
  onSubmit: PropTypes.func,
  pinStatus: asRequest(PropTypes.objectOf(PinShape)),
  tagOptions: SelectOptionsShape,
  themeOptions: SelectOptionsShape,
};

const mapStateToProps = state => ({
  defaultThemeOption: selectDefaultThemeOption(state),
  pinStatus: readPin(state, NEW_ITEM_ID),
  tagOptions: selectTagsOptions(state),
  themeOptions: selectThemesOptions(state),
});

const mapDispatchToProps = {
  onOpen: () => reset(NEW_ITEM_ID),
  onSubmit: values => create(values),
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPinManager);
